<template>
  <!--設定画面ページ ここから-->
  <div>
    <div class="setting-menu">
      <!--制限時間の設定-->
      <div
        class="setting-line"
        id="setting-time"
        :class="{ disabled: fixConfig.limit }"
      >
        <p class="setting-label">制限時間</p>
        <div class="setting-configs">
          <div class="setting-btns">
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'limit', value: false })"
              :class="{ clicked: !config.limit }"
              id="box_time_none"
            >
              なし
            </div>
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'limit', value: true })"
              :class="{ clicked: config.limit }"
              id="box_time_on"
            >
              あり
            </div>
          </div>
          <div class="qty" v-if="config.limit">
            <div class="btn-wrap">
              <img
                src="@/assets/img/minus.png"
                class="btn-minus btns"
                @touchstart.prevent="limitDownStart"
                @touchend.prevent="limitClear"
                @touchmove.prevent="limitMove"
                @mousedown.prevent="limitDownStart"
                @mouseleave.prevent="limitClear"
                @mouseup.prevent="limitClear"
                draggable="false"
                alt="-"
              />
            </div>
            <div class="limit-indi">
              <input
                v-model="config.limitTime"
                type="text"
                class="count"
                id="text_timelimit"
                name="qty"
                readonly
              />
              <p class="second">秒</p>
            </div>
            <div class="btn-wrap">
              <img
                src="@/assets/img/plus.png"
                class="btn-plus btns"
                @touchstart.prevent="limitUpStart"
                @mousedown.prevent="limitUpStart"
                @mouseleave.prevent="limitClear"
                @mouseup.prevent="limitClear"
                @touchend.prevent="limitClear"
                @touchmove.prevent="limitMove"
                draggable="false"
                alt="+"
              />
            </div>
          </div>
        </div>
      </div>
      <!--連続再生の設定-->
      <div
        class="setting-line"
        id="setting-mode"
        :class="{ disabled: fixConfig.continue }"
      >
        <p class="setting-label">連続再生</p>
        <div class="setting-configs">
          <div class="setting-btns">
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'continue', value: false })"
              :class="{ clicked: !config.continue }"
              id="box_mode_off"
            >
              OFF
            </div>
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'continue', value: true })"
              :class="{ clicked: config.continue }"
              id="box_mode_on"
            >
              ON
            </div>
          </div>
        </div>
      </div>
      <!-- 出題順の設定 -->
      <div
        class="setting-line"
        id="setting-level"
        :class="{ disabled: fixConfig.random }"
      >
        <p class="setting-label">出題順</p>
        <div class="setting-configs">
          <div class="setting-btns">
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'random', value: false })"
              :class="{ clicked: !config.random }"
              id="box_level_numerical"
            >
              問題番号順
            </div>
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'random', value: true })"
              :class="{ clicked: config.random }"
              id="box_mode_random"
            >
              ランダム
            </div>
          </div>
        </div>
      </div>
      <!-- 音声の設定 -->
      <div
        class="setting-line"
        id="setting-sound"
        :class="{ disabled: fixConfig.audio }"
      >
        <p class="setting-label">音声</p>
        <div class="setting-configs">
          <div class="setting-btns">
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'audio', value: false })"
              :class="{ clicked: !config.audio }"
              id="box_sound_off"
            >
              OFF
            </div>
            <div
              class="box actbtn"
              @click="$emit('setConfig', { key: 'audio', value: true })"
              :class="{ clicked: config.audio }"
              id="box_sound_on"
            >
              ON
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 初期設定に戻すボタン -->
    <ol class="btn-reset">
      <li
        @click="
          () => {
            initConfig(true);
          }
        "
      >
        初期値へ戻す
      </li>
    </ol>
    <!--設定画面ここまで-->
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  mounted() {
    // this.initConfig();
  },
  computed: {
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    fixConfig() {
      const keys = ["limit", "continue", "random", "audio"];
      const retObj = {};
      keys.forEach(elm => {
        if (this.drill.config) {
          if (this.drill.config[elm] !== null) {
            retObj[elm] = true;
            return;
          }
        }
        retObj[elm] = false;
      });
      return retObj;
    }
  },
  methods: {
    initConfig(init) {
      console.log("initConfig");
      const initConfig = this.drill.config;

      const configs = [
        "limitTime",
        "limit",
        "continue",
        "random",
        "audio",
        "expectLastCorrect"
      ];

      const commonSettings = ["continue", "random", "audio"];

      const defaultSetting = {
        limitTime: initConfig.limitTime || 10,
        limit: initConfig.limit || false,
        expectLastCorrect: initConfig.expectLastCorrect || false,
        continue: initConfig.continue || false,
        random: initConfig.random || false,
        audio: initConfig.audio || false,
      };

      configs.forEach(key => {
        let value, ls;
        let notLS = false;
        /*
        if (key === "limitTime" || key === "expectLastCorrect") {
          ls = localStorage.getItem(
            `SukenDrill::${this.setting.id}_${this.drill.id}::${key}`
          );
        } else {
          ls = localStorage.getItem(`SukenDrill::${this.setting.id}::${key}`);
        }
        */

        if (!init) {
          if (commonSettings.indexOf(key) !== -1) {
            console.log('common: ' + key);
            ls = localStorage.getItem(
              `SukenDrill::${this.setting.id}::${key}`
            );
          } else {
            ls = localStorage.getItem(
              `SukenDrill::${this.setting.id}_${this.drill.id}::${key}`
            );
          }
        }

        console.log(key, ls, typeof ls);
        if (ls && ls !== "undefined") {
          value = JSON.parse(ls);
        }

        console.log("fix", this.fixConfig[key], "init", initConfig[key]);

        if (this.fixConfig[key] !== null && initConfig[key] !== null) {
          value = initConfig[key];
          notLS = true;
        }

        if (value === null || value === undefined) {
          value = defaultSetting[key];
        }

        console.log(key, value);
        this.$emit("setConfig", {
          key,
          value,
          notLS
        });
      });
    },

    setLimit(e) {
      if (e < 1000 && 0 < e) {
        this.$emit("setConfig", {
          key: "limitTime",
          value: e
        });
      } else if (e <= 0) {
        this.$emit("setConfig", {
          key: "limit",
          value: false
        });
        this.limitClear();
      }
    },

    limitUpStart(event) {
      event.preventDefault();
      if (event.touches) {
        var touch = event.touches[0];
      }
      if (touch) {
        this.limitElem = document.elementFromPoint(touch.pageX, touch.pageY);
      }

      this.limitTimer = setInterval(() => {
        this.setLimit(this.config.limitTime + 1);
      }, 250);
      this.setLimit(this.config.limitTime + 1);
      return false;
    },

    limitDownStart(event) {
      event.preventDefault();
      if (event.touches) {
        var touch = event.touches[0];
      }
      if (touch) {
        this.limitElem = document.elementFromPoint(touch.pageX, touch.pageY);
      }

      if (this.config.limitTime - 1 > 0) {
        this.limitTimer = setInterval(() => {
          this.setLimit(this.config.limitTime - 1);
        }, 250);
      }
      this.setLimit(this.config.limitTime - 1);
      return false;
    },

    limitMove(event) {
      event.preventDefault();
      var touch = event.touches[0];
      if (
        this.limitElem !== document.elementFromPoint(touch.pageX, touch.pageY)
      ) {
        this.limitClear();
      }
      return false;
    },

    limitClear(event) {
      event.preventDefault();
      clearInterval(this.limitTimer);
    }
  }
};
</script>

<style scoped>
/*-- 設定  --*/

.setting-menu {
  position: relative;
  margin: 0 auto;
  top: 0.5rem;
}

.setting-line {
  position: relative;
  padding-bottom: 2rem;
}

.setting-label {
  font-size: 1.2rem;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.setting-line {
  position: relative;
  padding-bottom: 2rem;
}

.setting-configs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.setting-btns {
  display: flex;
  flex: 0 0 68%;
  height: 3.5rem;
  box-sizing: border-box;
}

@media (max-width: 576px) {
  .setting-configs {
    flex-direction: column;
  }

  .setting-btns {
    flex: 0 0 auto;
    justify-content: stretch;
    width: 100%;
  }
}

.setting-btns .box {
  display: flex;
  text-align: center;
  color: #000000;
  font-size: 1.2rem;
  background-color: #f2f2f2;
  cursor: pointer;

  width: 50%;

  justify-content: center;
  align-items: center;
}

.qty {
  display: flex;
  font-size: 1.5rem;
  flex: 1 1 auto;

  justify-content: flex-end;
  align-items: center;
}

.limit-indi {
  display: flex;
  flex: 0 0 auto;
}

.count {
  font-size: 1.2rem;
  font-weight: 400;
  text-align: center;
  background: #fff;
  border: 1px #fff;
  cursor: default;
  width: 3em;
}

.second {
  font-size: 0.8em;
  padding-top: 20px;
  font-family: "Rounded mplus";
}

@media (min-width: 768px) {
  .count {
    font-size: 1.8rem;
    font-weight: 400;
    text-align: center;
    background: #fff;
    border: 1px #fff;
    cursor: default;
    width: 3em;
  }
}

.btn-plus {
  height: auto;
  cursor: pointer;
}

.btn-minus {
  height: auto;
  cursor: pointer;
}

.btn-wrap {
  flex: 0 1 60px;
}

.btn-wrap .btns {
  width: 100%;
}

.btns:active {
  transform: translateY(10px);
}
</style>